module.exports = __webpack_public_path__ + "static/undraw_work_chat_erdt-f68f6b55d9f0c5da8f063963891fe6d9.svg";